import React, { useRef, useEffect } from 'react'
import styled from 'styled-components'
import { useMedia } from 'react-use'
import { withRouter, useHistory } from 'react-router-dom'
import { TrendingUp, List, PieChart, Disc, ArrowUpRight } from 'react-feather'
import { AutoColumn } from '../Column'
import Link, { BasicLink } from '../Link'
import getEnvironmentVar from '../../utils/getEnvironmentVar'
import { LightDivider } from '..'
import { MENU_LINKS, ENERGISWAP_LINKS } from '../../constants'
const version = getEnvironmentVar('VERSION')

const Wrapper = styled.div`
  height:  calc(100vh - 72px);
  background-color: ${({ theme }) => theme.black};
  color: ${({ theme }) => theme.text1};
  position: sticky;
  top: 72px;
  z-index: 99999;
  box-sizing: border-box;
  color: ${({ theme }) => theme.bg2};
  overflow-y: auto;
  width: 220px;

  @media screen and (max-width: 800px) {
   display: none;
  }
`

const TabletWrapper = styled.div`
  height: calc(100vh - 72px);
  background-color: ${({ theme }) => theme.black};
  color: ${({ theme }) => theme.text1};
  position: sticky;
  z-index: 9999;
  top: 72px;
  box-sizing: border-box;
  padding-top: 26px;
  color: ${({ theme }) => theme.bg2};
  overflow-y: auto;

  @media screen and (max-width: 800px) {
    display: none;
   }
`

const Option = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  font-size: 14px;
  opacity: ${({ activeText }) => (activeText ? 1 : 0.6)};
  color: ${({ theme }) => theme.white};
  opacity : 0.65;

  :hover {
    opacity: 1;
  }
`

const OptionTablet = styled.div` 
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-weight: 300;
  font-size: 10px;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  text-align: center;
  opacity: ${({ activeText }) => (activeText ? 1 : 0.6)};
  color: rgba(255, 255, 255, 0.85);
  display: flex;
  :hover {
    opacity: 1;
  }
`

const DesktopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const HeaderText = styled.div`
  margin-right: 0.75rem;
  font-size: 0.825rem;
  font-weight: 500;
  display: inline-box;
  display: -webkit-inline-box;
  opacity: 0.9;
  :hover {
    opacity: 1;
  }
  a {
    color: ${({ theme }) => theme.white};
  }
`
const VersionText = styled.div`
  margin-top: auto;
  padding-left: 24px;
  padding-bottom: 30px;
  font-size: 0.825rem;
  font-weight: 500;
  display: inline-box;
  display: -webkit-inline-box;
  opacity: 0.7;
  color: ${({ theme }) => theme.white};
`

const LinkCustom = styled(Link)`
  font-size: 14px;
  opacity: 0.7;

  :hover {
    opacity: 1;
  }
`

const HeadingDiv = styled.div`
  padding: 14px 24px;
  color: rgba(137, 138, 140, 0.95);
  font-size: 14px;
  font-weight: 500;

  :hover {
    cursor: default;
  }
`

const AutoColumnCustom = styled(AutoColumn)`
  gap: 14px;
  margin-left: 24px;
  margin-Bottom: 14px;
`

const TabletVersion = styled.p`
  position: absolute;
  bottom: 10px;
  left: 14px;
  opacity: 0.7;
  color: ${({ theme }) => theme.white};
`

const NavigationList = ({ menuLinks, history, close }) => {
  return Object.keys(menuLinks).map((key) => {
    return (
      <BasicLink key={key} to={menuLinks[key].to} onClick={() => close(false)}>
        <Option activeText={menuLinks[key].activeKeys.includes(history.location.pathname.split('/')[1])}>
          {menuLinks[key].icon}
          {menuLinks[key].text}
        </Option>
      </BasicLink>
    )
  })
}

const EnergiswapLinks = ({ type, close }) => {
  return Object.keys(ENERGISWAP_LINKS).map((key) => {
    return ENERGISWAP_LINKS[key].type === type ? (
      <HeaderText key={key}>
        <LinkCustom href={ENERGISWAP_LINKS[key].link} target="_blank" rel="noopener noreferrer" onClick={() => close(false)}>
          {ENERGISWAP_LINKS[key].name}<ArrowUpRight size={14} />
        </LinkCustom>
      </HeaderText>
    ) : ''
  })
}

const NavigationListTablet = ({ menuLinks, history }) => {
  return Object.keys(menuLinks).map((key) => {
    return (
      <BasicLink key={key} to={menuLinks[key].to} >
        <OptionTablet activeText={menuLinks[key].activeKeys.includes(history.location.pathname.split('/')[1])}>
          {menuLinks[key].icon}
          {menuLinks[key].text}
        </OptionTablet>
      </BasicLink>
    )
  })
}

const menuLinks = [
  { ...MENU_LINKS['HOME'], icon: <TrendingUp size={20} /> },
  { ...MENU_LINKS['TOKENS'], icon: <Disc size={20} /> },
  { ...MENU_LINKS['PAIRS'], icon: <PieChart size={20} /> },
  { ...MENU_LINKS['ACCOUNTS'], icon: <List size={20} /> },
  // Referral program removed
  // { ...MENU_LINKS['AFFILIATE'], icon: <DollarSign size={20} /> },
]

function SideNav({ sideMenuOpen, setSideMenuOpen }) {
  const below1080 = useMedia('(max-width: 1080px)')
  const history = useHistory()

  // To close sidemenu and end blur when mouse clicked outside of side menu
  const sideMenuTabletRef = useRef()
  useEffect(() => {
    const clickOut = (e) => {
      if (!sideMenuTabletRef?.current?.contains(e.target)) {
        setSideMenuOpen(false)
      }
    }
    window.addEventListener('mousedown', clickOut)
    return () => {
      window.removeEventListener('mousedown', clickOut)
    }
  }, [setSideMenuOpen])

  return (
    <>
      {!below1080 || sideMenuOpen ? (
        <Wrapper isMobile={below1080} menu={sideMenuOpen ? 1 : 0} ref={sideMenuTabletRef}>
          <DesktopWrapper>
            <HeadingDiv>ANALYTICS</HeadingDiv>
            <AutoColumnCustom>
              <NavigationList menuLinks={menuLinks} history={history} close={setSideMenuOpen} />
            </AutoColumnCustom>
            <LightDivider />

            <HeadingDiv>ENERGISWAP</HeadingDiv>
            <AutoColumnCustom>
              <EnergiswapLinks type={'energiswap'} close={setSideMenuOpen} />
            </AutoColumnCustom>
            <LightDivider />

            <HeadingDiv>HELP</HeadingDiv>
            <AutoColumnCustom>
              <EnergiswapLinks type={'help'} />
            </AutoColumnCustom>
            <LightDivider />

            <HeadingDiv>JOIN COMMUNITY</HeadingDiv>
            <AutoColumnCustom>
              <EnergiswapLinks type={'community'} />
            </AutoColumnCustom>
            <VersionText>
              Version {version}
            </VersionText>
          </DesktopWrapper>
        </Wrapper >
      ) : (
        <TabletWrapper>
          <NavigationListTablet menuLinks={menuLinks} history={history} />
          <TabletVersion>v{version}</TabletVersion>
        </TabletWrapper>

      )}
    </>
  )
}

export default withRouter(SideNav)
